/**
 * Environment utilities exports
 * Each environment variable has its own dedicated function for type safety
 */
export {
    // Public variables
    getPublicUrl,
    getAssetPrefix,
    getBasePath,
    getGoogleMapsApiKey,
    getGtmId,
    getApiUrl,
    getVacasaApiUrl,
    isCouponEnabled,
    getSegmentWriteKey,
    // App mode
    isStaging,
    isProduction,
    isMaintenance,
    getAppMode,
    isBookingDisabled,
    isAvailableMarketEnabled,
    // Node environment (server-only)
    getGoogleMapsSigningSecret,
    isEnableLogger,
    isAnalyzeEnabled,
} from "./env";
